/* eslint-disable sonarjs/no-duplicate-string */
import {
	COLOR_RPG_BACKGROUND,
	COLOR_RPG_FRAME,
	COLOR_RPG_TEXT,
} from 'constants/color';
import {
	PADDING_RPG_FRAME,
	SIZE_BORDER,
	SIZE_FONT_BASE,
	WIDTH_SERIF_FRAME,
} from 'constants/size';
import { getFontFamily } from 'hooks/useFonts';
import { appSelector } from 'modules/app/appSelector';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useSelector } from 'react-redux';

const statusFrameWidth = SIZE_FONT_BASE * 6;
const statusRowWidth = statusFrameWidth - PADDING_RPG_FRAME * 2;

const styles = StyleSheet.create({
	container: {
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		backgroundColor: COLOR_RPG_BACKGROUND,
		padding: 30,
	},
	rpgFrame: {
		flexDirection: 'column',
		backgroundColor: COLOR_RPG_BACKGROUND,
		borderColor: COLOR_RPG_FRAME,
		borderWidth: SIZE_BORDER,
		borderRadius: 10,
		margin: 10,
		paddingHorizontal: PADDING_RPG_FRAME,
		paddingBottom: SIZE_FONT_BASE / 2,
	},
	statusFrame: {
		width: statusFrameWidth,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
	},
	statusRowCenter: {
		width: statusRowWidth,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	alignRight: {
		flexDirection: 'column',
		justifyContent: 'flex-end',
		alignItems: 'flex-end',
	},
	serifFrame: {
		width: WIDTH_SERIF_FRAME,
		justifyContent: 'center',
		alignItems: 'flex-start',
	},
	text: {
		fontFamily: getFontFamily('dq'),
		fontSize: SIZE_FONT_BASE,
		color: COLOR_RPG_TEXT,
	},
	nameContainer: {
		position: 'absolute',
		top: -SIZE_FONT_BASE * 0.8,
		left: 0,
		width: statusFrameWidth,
		height: SIZE_FONT_BASE,
		justifyContent: 'center',
		alignItems: 'center',
	},
	nameText: {
		backgroundColor: COLOR_RPG_BACKGROUND,
		paddingHorizontal: 10,
	},
});

// eslint-disable-next-line react/display-name
const Result = React.forwardRef<View>((props, ref) => {
	const name = useSelector(appSelector.selectName);
	const job = useSelector(appSelector.selectJob);
	const sex = useSelector(appSelector.selectSex);
	const serif = useSelector(appSelector.selectSerif);
	const level = useSelector(appSelector.selectLevel);
	const hp = useSelector(appSelector.selectHp);
	const mp = useSelector(appSelector.selectMp);

	return (
		<View style={styles.container} ref={ref} collapsable={false}>
			<View style={[styles.rpgFrame, styles.statusFrame]}>
				<View style={styles.nameContainer}>
					<Text style={[styles.text, styles.nameText]}>{name}</Text>
				</View>
				<View style={styles.statusRowCenter}>
					<Text style={styles.text}>{job}</Text>
				</View>
				<View style={styles.statusRowCenter}>
					<Text style={styles.text}>{`${sex}`}</Text>
				</View>
				<View style={styles.statusRowCenter}>
					<View style={styles.alignRight}>
						<Text style={styles.text}>{`レベル:${level}`}</Text>
						<Text style={styles.text}>{`HP:${hp}`}</Text>
						<Text style={styles.text}>{`MP:${mp}`}</Text>
					</View>
				</View>
			</View>
			<View style={[styles.rpgFrame, styles.serifFrame]}>
				<Text style={styles.text}>{serif}</Text>
				<Text style={styles.text}>▼</Text>
			</View>
		</View>
	);
});

export default Result;
